<template>
  <transition name="slide-fade" mode="out-in">
    <div class="i-no-results">
      <img src="../../assets/img/icons/compass-dark.svg" alt="">
      <h2>{{ title }}</h2>
      <p>{{ subTitle }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'noResults',
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/noResults.vue